import React, { useState } from "react"

import { Modal, ModalBody, ModalHeader } from "reactstrap"
import Success from "../assets/images/gif/success.gif"

import closeIcon from "../assets/images/icons/close.svg"
function SignatureCapturedModal({ open, setOpen }) {
  const toggle = () => setOpen(!open)
  return (
    <div>
      <Modal isOpen={open} toggle={toggle} centered className="custom-size">
        <ModalBody>
          <div className="signature-captured-modal-wrapper">
            <img height={"150px"} src={Success} alt="" />
            <h4>Signature Captured Successfully</h4>
            <p>You are being redirected to the next step</p>
          </div>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default SignatureCapturedModal
